// Sends a file straight to Bunny with the TUS signature the API created for that video.
function tusRequest(method: string, url: string, upload: any, headers: any, body: any, onProgress: (percent: number) => void): Promise<XMLHttpRequest | null> {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader("Tus-Resumable", "1.0.0");
    xhr.setRequestHeader("AuthorizationSignature", upload.signature);
    xhr.setRequestHeader("AuthorizationExpire", String(upload.expires));
    xhr.setRequestHeader("VideoId", upload.videoId);
    xhr.setRequestHeader("LibraryId", upload.libraryId);
    Object.keys(headers).forEach((h) => xhr.setRequestHeader(h, headers[h]));
    xhr.upload.onprogress = (e: ProgressEvent) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => resolve(xhr.status >= 200 && xhr.status < 300 ? xhr : null);
    xhr.onerror = () => resolve(null);
    xhr.send(body);
  });
}

export async function uploadToBunny(file: File, upload: any, onProgress: (percent: number) => void): Promise<boolean> {
  const created = await tusRequest("POST", upload.endpoint, upload, {
    "Upload-Length": String(file.size),
    "Upload-Metadata": `filetype ${btoa(file.type || "video/mp4")}`
  }, null, onProgress);
  const location = created && created.getResponseHeader("Location");
  if (!location) return false;

  const patched = await tusRequest("PATCH", new URL(location, upload.endpoint).toString(), upload, {
    "Upload-Offset": "0",
    "Content-Type": "application/offset+octet-stream"
  }, file, onProgress);
  return patched !== null;
}
